module.exports = __webpack_public_path__ + "static/media/fnb_asia.10abcfb9.svg";